export default __webpack_public_path__ + "static/media/sweet-1.c495c742.jpg";